var React = require('react');

function IcAppsMobileActive (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"7","y":"2","width":"34","height":"44","rx":"4","fill":"#ffe6d6","key":0}),React.createElement("rect",{"x":"10","y":"5","width":"28","height":"33","rx":"2","fill":"#ffc39c","key":1}),React.createElement("circle",{"cx":"24","cy":"42","r":"2","fill":"#ffc39c","key":2})]);
}

IcAppsMobileActive.defaultProps = {"id":"ic-apps-mobile-active","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcAppsMobileActive;

IcAppsMobileActive.default = IcAppsMobileActive;
